import { Text } from '@innovationdepartment/proxima-ui';

import { ErrorText } from '../CastingProfile.styles';
import ChipToggleGroup from './ChipToggleGroup';

type MetadataChipGroupProps = {
  label: string;
  options: Array<{ value: string; display: string }>;
  selected: string[];
  onChange: (selected: string[]) => void;
  error?: string;
};

const MetadataChipGroup = ({
  label,
  options,
  selected,
  onChange,
  error
}: MetadataChipGroupProps) => {
  const toggle = (value: string) =>
    onChange(
      selected.includes(value) ? selected.filter(item => item !== value) : [...selected, value]
    );

  // Fragment so the heading and chips are direct FormSection children and pick
  // up its gap, matching the heading spacing of the other sections
  return (
    <>
      <Text variant="h5">{label}</Text>
      <ChipToggleGroup options={options} selected={selected} onToggle={toggle} />
      {error ? <ErrorText>{error}</ErrorText> : null}
    </>
  );
};

export default MetadataChipGroup;
